import React, { useEffect, useState } from 'react';
import useParam from '../../context/ParamContext';

const ChipContent = ({ eventInfo }) => {
  const { params } = useParam();
  const [chipObj, setChipObj] = useState(null);

  useEffect(() => {
    let paramKey = 'TASKPLANNER_CHIP_CONTENT';

    if (params[paramKey]) {
      const parsedObj = JSON.parse(params[paramKey]);
      setChipObj(parsedObj);
    }
  }, [params]);

  const task = eventInfo.event._def.extendedProps.eventData;

  const getFieldValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => {
      if (Array.isArray(acc)) {
        return acc.map((item) => item[part]);
      } else {
        return acc ? acc[part] : null;
      }
    }, obj);
  };

  const setChipContent = () => {
    if (!chipObj || !task) {
      return null;
    }

    return (
      <span className="truncate block" style={{ marginTop: '2px', marginBottom: '2px' }}>
        {chipObj
          .map((item) => {
            const { label } = item;
            let taskValue = getFieldValue(task, label);
            return taskValue;
          })
          .filter((value) => value !== null && value !== undefined && value !== '')
          .map((value, index) => (
            <span key={index}>
              {index > 0 && ' - '}
              {value}
            </span>
          ))}
      </span>
    );
  };

  return <div>{setChipContent()}</div>;
};

export default ChipContent;
